import React from "react"
import { useNavigate } from "react-router-dom"
import {
	BooleanProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { BmiCard } from "./BmiCard"
import { useBmi } from "./useBmi"

interface CapioNexusBmiBlockProps {
	header: StringProperty
	description: StringProperty
	resultPage: string
	heightInput: string
	weightInput: string
	heightUnit: string
	weightUnit: string
	submitButton: string
	marginBottom?: BooleanProperty
}

const CapioNexusBmiBlock: React.FC<CapioNexusBmiBlockProps> = ({
	header,
	description,
	resultPage,
	heightInput,
	weightInput,
	submitButton,
	marginBottom,
}) => {
	const navigate = useNavigate()
	const { setLength, setWeight } = useBmi()
	const onBmiCalculated = (length, weight) => {
		setLength(length)
		setWeight(weight)
		navigate(resultPage)
	}
	return (
		<BmiCard
			onBmiCalculated={onBmiCalculated}
			header={header.value}
			description={description.value}
			inputTexts={{
				length: heightInput,
				weight: weightInput,
				button: submitButton,
			}}
			marginBottom={marginBottom}
		/>
	)
}

export { CapioNexusBmiBlock }
